/*-----------------------------------------------------------
 Functions for the Match Funding Form page
------------------------------------------------------------*/

var TECL_MatchFundingForm = {
  
  /**
   * Form Initialise routine
   */
  Initialise: function() {

    $(".match-funding-form form").submit(function(e) {
      // Before submission, so some client side validation
      if (TECL_MandatoryFields.Validate(this, false, true)) {
        $(".match-funding-form .requiredFieldError").addClass("hidden");
      } else {
        $(".match-funding-form .requiredFieldError").removeClass("hidden");
        e.preventDefault();
      }
    });
  }
};